const defaultTableColumns = [
    {
        title: 'Quadra',
        sortable: true,
        data: 'block',
        active: true
    },
    {
        title: 'Andar',
        sortable: true,
        data: 'floor',
        active: true
    },
    {
        title: 'Lote',
        sortable: true,
        data: 'number',
        active: true
    },
    {
        title: 'Metragem',
        sortable: true,
        data: 'area',
        active: true
    },
    {
        title: 'Etapa',
        sortable: true,
        data: 'stage',
        active: true
    },
    {
        title: 'Valor',
        sortable: true,
        data: 'value',
        active: true
    },
    {
        title: 'Status',
        sortable: false,
        data: 'situation',
        active: true
    },
    {
        title: '',
    },
]

const filters = [
    {
        component: 'select-tags',
        label: "Status",
        disabled: false,
        hidden: false,
        multiple: true,
        options: [
            { label: 'Disponível', value: 'available' },
            { label: 'Pré-reserva', value: 'pre-reserve' },
            { label: 'Reservado', value: 'reserved' },
            { label: 'Reserva Permanente', value: 'reserved-permanetly' },
            { label: 'Vendido', value: 'sale' },
            { label: 'Indisponível', value: 'unavailable' }
        ],
        returnValue: 'value',
        params: {
            name: 'situations',
            value: null
        },
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Quadra/Torre",
        disabled: false,
        hidden: false,
        multiple: true,
        service: 'availability',
        method: 'getBlocks',
        handler: 'blockHandler',
        itemLabel: 'label',
        searchAble: true,
        serviceParams: [],
        options: [],
        parse(data, availabilityType) {
            const label = availabilityType === 'horizontal' ? 'Quadra' : 'Torre'

            return Object.values(data).map(option => {
                return { label: `${label} ${option.block}`, value: option.block }
            })
        },
        returnValue: 'value',
        params: {
            name: 'blocks',
            value: null
        },
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
        openEvent: 'units-list-blocks'
    },
    {
        component: 'select-tags',
        label: "Etapa",
        disabled: false,
        hidden: false,
        searchAble: false,
        multiple: true,
        options: [],
        returnValue: 'value',
        params: {
            name: 'stages',
            value: null
        },
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
        openEvent: 'units-list-stages'
    }
]

export { defaultTableColumns, filters }

